"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTotalFilteredTiles = void 0;

var getTotalFilteredTiles = function getTotalFilteredTiles(_ref) {
  var savedFilesCount = _ref.savedFilesCount,
      files = _ref.files,
      tiles = _ref.tiles;
  return tiles.count() + (savedFilesCount - files.count());
};

exports.getTotalFilteredTiles = getTotalFilteredTiles;